/* eslint-disable react-native/no-inline-styles */
import React, { memo } from 'react'

import i18n from '@batical/i18n'
import { styled } from '@mui/material'

import { defaultLineHeight } from '../Metrics'
import { Text } from '../Native/Text'

export type SeparatorProps = {
  height?: number
  text?: string
  first?: boolean
  last?: boolean
  backgroundColor?: string
  empty?: boolean
}
const SeparatorLine = ({
  text,
  first = true,
  last = false,
  height = defaultLineHeight,
  empty = false,
  backgroundColor = '#f1f5f9'
}: SeparatorProps) => {
  if (empty) {
    return <div style={{ marginTop: 28 }} />
  }

  const hasColor = backgroundColor !== '#f1f5f9' && backgroundColor !== 'white'

  return (
    <div
      style={{
        minHeight: height,
        backgroundColor: hasColor ? `${backgroundColor}CC` : '#f1f5f9',
        marginTop: 24,
        borderRadius: 12,
        display: 'flex',
        alignItems: 'center',
        paddingLeft: 16,
        paddingRight: 16,
        ...(hasColor
          ? { boxShadow: `0 2px 10px ${backgroundColor}30` }
          : { border: '1px solid #e2e8f0' })
      }}>
      {text && (
        <TextLine style={{ color: hasColor ? '#ffffff' : '#334155' }}>
          {i18n.t(text)}
        </TextLine>
      )}
    </div>
  )
}

export default memo(SeparatorLine)

const TextLine = styled(Text)`
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  padding-top: 2px;
  padding-bottom: 2px;
  flex-wrap: wrap;
  text-align: left;
`
